import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {map} from 'rxjs/operators';
import {ConfigAPIService} from '@app/services/api/config-api.service';

export const carpeakDashboardGuard: CanActivateFn = () => {
  const router = inject(Router);

  return inject(ConfigAPIService).isCarpeakAccount().pipe(
    map((isCarpeak) => isCarpeak ? router.createUrlTree(['/admin/vehicles']) : true)
  );
};
